import React, { useState } from "react";
import chatPerson from "../../../images/img/chat-person.png";
import { styled } from '@mui/material/styles';
import { IconButton, Box, Tooltip } from '@mui/material';
import ThumbsUp from '../../../images/feedBack/thumps-up.svg';
import ThumbsDown from '../../../images/feedBack/thumps-down.svg';
import ThumbsUpFilled from '../../../images/feedBack/thumps-up-filled.svg';
import ThumbsDownFilled from '../../../images/feedBack/thumps-down-filled.svg';
import MessageA433 from "./MessageA433";
import apiService from "../../APIService";


const CustomIconButton = styled(IconButton)(({ theme }) => ({
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    backgroundColor: '#fff',
    margin: '0 10px',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '25px',
      color: '#E940AD',
    },
    '&.Mui-disabled': {
      backgroundColor: '#fff', // Ensure the background color remains the same when disabled
    },
  }));

const MessageA444 = (props) => {
    const {inputValue ,handleClick, setTextOnClick ,setChatClosed,setMinimized,setShowClose,scrollToBottom ,setChatData } = props
    const data = JSON.parse(props?.item?.data);
    const [selectedButton, setSelectedButton] = useState(null);
    const [clicked, setClicked] = useState(false);
    const [showFeedback, setShowFeedback] = useState(false);
    const [response , setRespnse] = useState({})
    const [isDisable , setIsDisable] = useState(false)

    const handleButtonClick = (button) => {
        if (selectedButton === null) {
            setSelectedButton(button);
        }
    };
    

    const onClickHandler = (e) => {
       
        if(e === 'Skip Feedback'){
            setIsDisable(true)
            props.handleClick(data?.button?.code, 'SKIP_FEEDBACK', props.item.uiCommand);
            props.setTextOnClick('Skip Feedback');
        }else{
            localStorage.setItem("onClickedYesFlow", true);
            setChatData([])
            setChatClosed(true)
            setMinimized(false)
            setShowClose(true)
        }
       
        // if (!props.disable) {
        //     props.handleClick(props.item.code, data, props.item.uiCommand);
        //     setClicked(true);
        // }
    };

    const handleFeedbackClick  = async (code, input, uiCommand) => {
        // props.handleClick(data?.code, data, '');
        setIsDisable(true)
        if(input === 'THUMBS_UP'){
            props.handleClick(code, input, uiCommand)
            return
        }
        const response = await apiService.chat(code ,input);
        setRespnse(response?.data?.chatResponse?.entries)
        if (uiCommand === "A433") {
            setShowFeedback(true);
        }
        scrollToBottom()
    };

    return (
        <>
            <div style={{ display: "flex", width: "100%" }}>
                <div className="chat-person" style={{ marginTop: "10px" }}>
                    <img src={chatPerson} alt="" />
                </div>
                <div className="chat-text" style={{ margin: "10px 10px" }} aria-live="polite">
                    <div dangerouslySetInnerHTML={{ __html: data.text }}></div>
                    <Box display="flex" justifyContent="center" alignItems="center" height="16vh">
                        <CustomIconButton onClick={() => {
                            handleButtonClick('thumbsUp');
                            handleFeedbackClick(props?.item?.code, 'THUMBS_UP', props?.item?.uiCommand);
                        }}
                        disabled={isDisable}
                        >
                            {selectedButton === 'thumbsUp' ? (
                                <img src={ThumbsUpFilled} alt="" />
                            ) : (
                                <img src={ThumbsUp} alt="" />
                            )}
                        </CustomIconButton>
                        <CustomIconButton onClick={() => {
                            handleButtonClick('thumbsDown');
                            handleFeedbackClick(props?.item?.code, 'THUMBS_DOWN', "A433");
                        }}
                        disabled={isDisable}
                        >
                              {selectedButton === 'thumbsDown' ? (
                                <img src={ThumbsDownFilled} alt="" />
                            ) : (
                                <img src={ThumbsDown} alt="" />
                            )}
                        </CustomIconButton>
                    </Box>
                    <Tooltip>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <button
                                className={!props.disable ? "chat-label action-tab" : "chat-labelnohover action-tab"}
                                id="main-tab1"
                                style={{
                                    color: clicked && "grey",
                                    pointerEvents: clicked && "none",
                                }}
                                onClick={() => onClickHandler(data?.button?.button_text)}
                                disabled={isDisable}
                            >
                                {data?.button?.button_text}
                            </button>
                        </div>
                    </Tooltip>
                    {showFeedback && <MessageA433 response={response} inputValue={inputValue} handleClick={handleClick} setTextOnClick={setTextOnClick} setShowFeedback={setShowFeedback}/>}
                </div>
            </div>
        </>
    );
};

export default MessageA444;
